import { dashboardSettings } from "./dashboardSettingsConstants";

export const sideBarSettings = {
    cardProps: { p: 4, mx: 4, borderRadius: dashboardSettings.borderRadius },
    style: { backgroundColor: "#EFEFEF" },
};
